import { render, staticRenderFns } from "./vs-form-text.vue?vue&type=template&id=7f71dbc2&scoped=true"
import script from "./vs-form-text.vue?vue&type=script&lang=js"
export * from "./vs-form-text.vue?vue&type=script&lang=js"
import style0 from "./vs-form-text.vue?vue&type=style&index=0&id=7f71dbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f71dbc2",
  null
  
)

export default component.exports